<script setup>
import { Link } from '@inertiajs/inertia-vue3'
</script>
<template>

    <Head>
        <title>Consulta Pública - {{ categoria.nombre }}</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Consulta Pública</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 text-center text-md-left mb-4 text-2xl">
                        <h3>Consultas disponibles para <span class="font-weight-bold">{{ categoria.nombre }}</span></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-12 mb-5" v-for="(item, index) in datos" :key="index">
                        <div class="item">
                            <div class="text p-4">
                                <img src="/img/mejora/file.png" />
                                <div class="titulo font-weight-bold">{{ item.nombre }}</div>
                                <hr noshade="noshade" />
                                <div class="fecha">Vigencia: {{ $filters.getDate(item.vigencia_consulta) }}</div>
                            </div>
                            <div class="action p-3">
                                <a :href="route('consulta.formulario', { categoria: categoria.slug, id: item.id })" class="boton-principal boton-flecha">Consultar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
    },
    props: {
        seccion: Object,
        categoria: Object,
        datos: Object,
    },
}
</script>
<style scoped>
.bloque-general__encabezado {
    margin-top: 50px;
}

h2 {
    margin-top: 0;
}

.boton-secundario {
    padding: 8px 20px;
    font-size: 16px;
}

.item {
    height: 100%;
    font-size: 1.0625rem;
    background: #FFFFFF;
    box-shadow: .125rem .125rem .625rem 0 rgba(0, 0, 0, 0.23);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 15px;
}

.item .text {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.item .text .titulo {
    line-height: 1.1em;
    margin-top: 20px;
    text-align: center;
}

.item .action {
    background: #F9F9F9;
    text-align: center;
}

.item .fecha {
    font-family: "Playfair Display", Georgia, serif;
    font-size: 16px;
    color: #505050;
    text-align: center;
    display: flex;
    align-items: baseline;
    line-height: 1.3em;
    margin-top: 10px;
}

.item hr {
    border-top: 1px solid #d1d1d1;
    width: 100%;
    margin-bottom: 5px;
    margin-top: 20px;
}
</style>
